<!-- =========================================================================================
  File Name: MemberAddTabInformation.vue
  Description: Member Add Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

    <!-- Content Row -->
    <div class="vx-row"> 
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="* ID" v-model="userID" v-validate="'required|min:4|max:15|'" name="userID"
        placeholder="영문으로 시작되는 4~15자리의 영문과 숫자로 입력해주세요." />
        <span class="text-danger text-sm" v-show="errors.has('userID')">{{ errors.first('userID') }}</span>

        <vs-input class="w-full mt-4" label="* 비밀번호" v-model="password" ref="password" type="password" v-validate="'required|min:6|max:32|'" name="password" 
        placeholder="6~32자리이상의 영문과 숫자로 입력해주세요."/>
        <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
 
        <vs-input class="w-full mt-4" label="* 비밀번호 확인" v-model="confirm_password" type="password" v-validate="'required|min:6|max:32|confirmed:password'" data-vv-as="password" name="confirm_password" 
        placeholder="6~32자리이상의 영문과 숫자로 입력해주세요."/>
        <span class="text-danger text-sm" v-show="errors.has('confirm_password')">{{ errors.first('confirm_password') }}</span>

        <vs-input class="w-full mt-4" label="* 이름" v-model="name" v-validate="'required|min:2|max:15|'" name="name" 
        placeholder="2~15자리의 한글과 영문, 숫자로 입력해주세요."/>
        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>

        <vs-input class="w-full mt-4" label="전화번호" v-model="telephone" v-validate="'max:25'" name="telephone" 
        placeholder="ex) 063-289-4404"/>
        <span class="text-danger text-sm" v-show="errors.has('telephone')">{{ errors.first('telephone') }}</span>

        <vs-input class="w-full mt-4" label="핸드폰번호" v-model="mobilephone" name="mobilephone" v-validate="'max:25'"
        placeholder="ex) 016-289-4404" />
        <span class="text-danger text-sm" v-show="errors.has('mobilephone')">{{ errors.first('mobilephone') }}</span>

        <vs-input class="w-full mt-4" label="이메일" v-model="eMail" v-validate="'email'" type="email" name="eMail" />
        <span class="text-danger text-sm" v-show="errors.has('eMail')">{{ errors.first('eMail') }}</span>

      </div>

      <div class="vx-col md:w-1/2 w-full"> 
        <div class="flex flex-wrap mt-4">
          <div class="w-1/2">
            <vs-input class="w-full" label="우편번호" disabled v-model="zipCode"  name="zipCode" />
            <!-- <span class="text-danger text-sm" v-show="errors.has('zipCode')">{{ errors.first('zipCode') }}</span> -->
          </div>
          <div class="w-1/2">
            <vs-button class="mt-5 ml-4" @click="popupActive=true">주소 검색</vs-button>
          </div>
        </div>
       
        <vs-input class="w-full mt-4" label="주소" disabled v-model="zipName" name="zipName" />
        <!-- <span class="text-danger text-sm" v-show="errors.has('zipName')">{{ errors.first('zipName') }}</span> -->

        <vs-input class="w-full mt-4" label="주소세부" v-model="zipDetail" name="zipDetail" />
        <span class="text-danger text-sm" v-show="errors.has('zipDetail')">{{ errors.first('zipDetail') }}</span>

        <vs-select v-model="instituteSeq" label="* 소속학원" class="mt-4 w-full" name="item-instituteSeq" v-validate="'required|max:25'">
          <vs-select-item :key="item.instituteSeq" :value="item.instituteSeq" :text="item.instituteName" v-for="item in instituteOptions" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('item-instituteSeq')">{{ errors.first('item-instituteSeq') }}</span>
  
        <vs-select v-model="userType" label="* 사용자타입" class="mt-4 w-full" name="item-usertype" v-validate="'required'">
          <vs-select-item :key="item.userType" :value="item.userType" :text="item.description" v-for="item in userTypeOptions" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('item-usertype')">{{ errors.first('item-usertype') }}</span>
  
        <!-- <div class="mt-4">
          <label class="vs-input--label">소속학원</label>
          <v-select label="instituteName" v-model="instituteSeq" :clearable="false" :options="instituteOptions" v-validate="'required'" name="instituteSeq" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has('instituteSeq')">{{ errors.first('instituteSeq') }}</span>
        </div> 

        <div class="mt-4">
          <label class="vs-input--label">사용자타입</label>
          <v-select label="userTypeName" v-model="userType" :clearable="false" :options="userTypeOptions" v-validate="'required'" name="userType" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has('roluserTypee')">{{ errors.first('userType') }}</span>
        </div> -->
    </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="confirmSave" :disabled="!validateForm">저장</vs-button>
          <!-- <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button> -->
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">취소</vs-button>
        </div>
      </div>
    </div>

    <!-- Daum 우편번호 서비스 -->
    <vs-popup class="holamundo" title="주소 검색" :active.sync="popupActive">
      <p>
        <vue-daum-postcode @complete="this.daumPostCode" />
      </p>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { VueDaumPostcode } from 'vue-daum-postcode'

import { fetchData, postData } from '@/api/module'


export default {
  components: {
    vSelect,
    VueDaumPostcode
  },
  /*props: {
    data: {
      type: Object,
      default: () => {}
      // required: true
    }
  },*/
  data () {
    return {
      popupActive: false,
      instituteOptions: [],
      userTypeOptions: [],
      branchSeq: '',
      createDate: '',
      eMail: '',
      instituteSeq: '',
      lastUpdateDate: '',
      mobilephone: '',
      name: '',
      password: '',
      confirm_password: '',
      photo: '',
      status: '',
      telephone: '',
      userID: '',
      userType: ' ',
      zipCode: '',
      zipDetail: '',
      zipName: ''
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.userID && this.password && this.name
       && this.instituteSeq && this.userType //&& this.zipCode && this.zipName
    }
  },
  methods: {
    daumPostCode (value) {
      // console.log(`result: ${JSON.stringify(value)}`)
      this.zipCode = value.zonecode
      this.zipName = value.address

      this.popupActive = false
    },
    confirmSave () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '회원 추가',
        text: '저장 하시겠습니까?',
        accept: this.save,
        acceptText: '저장'
      })
    },
    async save () {
      if (!this.validateForm) return

      try {
        const { data } = await postData('member', {
          userID : this.userID,
          password : this.password,
          name : this.name,
          telephone : this.telephone,
          zipCode : this.zipCode,
          zipName : this.zipName,
          zipDetail : this.zipDetail,
          instituteSeq : this.instituteSeq,
          userType : this.userType,

          mobilephone : this.mobilephone,
          eMail : this.eMail
          
          // status : this.status ,
          // photo : this.photo ,
        })
        console.log(data)
        this.$router.push('/member/member-list')
        this.showSaveSuccess()

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    showSaveSuccess () {
      this.$vs.notify({
        color: 'success',
        title: '회원 추가',
        text: '저장 되었습니다.'
      })
    },
    async loadInstitutes () {
      try {
        const keyword = ''
        const institutes = await fetchData('institute/search', keyword)
        this.instituteOptions = institutes.data.list
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    async loadUserType () {
      try {
        const userTypes = await fetchData('member-type')
        this.userTypeOptions = userTypes.data.list
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  },
  created () {
    this.loadInstitutes()
    this.loadUserType()
  }
}
</script>
